<template>
	<div> 
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Nome</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.nome" 
		        	:id="name+'nome'" 
		        	@input="clearValidation('nome')">
		        <div class="invalid-feedback" :id="name+'nome-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Icone</label>
		        <input 
		        	type="text" 
		        	class="form-control" 
		        	v-model="dados.icone" 
		        	:id="name+'icone'" 
		        	@input="clearValidation('icone')">
		        <div class="invalid-feedback" :id="name+'icone-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Cor</label>
		        <select
		        	class="form-control"
		        	v-model="dados.cor"
		        	:id="name+'cor'">
		        	<option value="primary">Azul</option>
		        	<option value="success">Verde</option>
		        	<option value="danger">Vermelho</option>
		        	<option value="warning">Amarelo</option>
		        </select>
		        <div class="invalid-feedback" :id="name+'cor-invalid-feedback'"></div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados)
			}
		},
		methods : {
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			},
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>